<template>
  <div class="bg-white mt-2">
    <!-- Header with aggregate -->
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-50">
      <h2 class="text-[13px] font-bold text-gray-800">
        商品評價
      </h2>
      <div v-if="avgRating > 0" class="flex items-center space-x-1.5">
        <StarRating :value="Math.round(avgRating)" :readonly="true" size="sm" />
        <span class="text-[12px] text-gray-500 font-medium">
          {{ avgRating }} / 5
        </span>
        <span class="text-[11px] text-gray-400">({{ totalCount }})</span>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading && !reviews.length" class="px-5 py-8 text-center">
      <span
        class="animate-spin w-5 h-5 border-2 border-primary border-t-transparent
               rounded-full inline-block"
      />
    </div>

    <!-- Empty state -->
    <div
      v-else-if="!reviews.length && !loading"
      class="px-5 py-8 text-center text-[13px] text-gray-400"
    >
      暫無評價，成為第一個評價者吧
    </div>

    <!-- Review items -->
    <ul v-else class="divide-y divide-gray-50">
      <li
        v-for="review in reviews"
        :key="review.id"
        class="px-5 py-4"
      >
        <div class="flex items-center justify-between mb-1.5">
          <div class="flex items-center space-x-2">
            <span class="text-[13px] font-medium text-gray-700">
              {{ review.customer && review.customer.name || '匿名' }}
            </span>
            <StarRating :value="review.rating" :readonly="true" size="sm" />
          </div>
          <span class="text-[11px] text-gray-400">{{ formatDate(review.created_at) }}</span>
        </div>
        <p
          v-if="review.comment"
          class="text-[12px] text-gray-600 leading-relaxed"
        >
          {{ review.comment }}
        </p>
      </li>
    </ul>

    <!-- Load more -->
    <div
      v-if="hasMore"
      class="px-5 py-3 border-t border-gray-50 text-center"
    >
      <button
        type="button"
        class="text-[12px] text-primary font-medium hover:opacity-80
               transition-opacity disabled:opacity-40"
        :disabled="loading"
        @click="loadMore"
      >
        <span
          v-if="loading"
          class="animate-spin w-3 h-3 border-2 border-primary border-t-transparent
                 rounded-full inline-block align-middle mr-1"
        />
        查看更多評價
      </button>
    </div>
  </div>
</template>

<script>
import StarRating from '@/components/review/StarRating.vue';
import { formatDate } from '@/utils/date';

export default {
  components: { StarRating },

  props: {
    categoryId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      reviews: [],
      avgRating: 0,
      totalCount: 0,
      page: 1,
      lastPage: 1,
      loading: false,
    };
  },

  computed: {
    hasMore() {
      return this.page < this.lastPage;
    },
  },

  created() {
    this.fetchReviews();
  },

  methods: {
    formatDate,

    async fetchReviews() {
      this.loading = true;

      try {
        const { data } = await this.$axios.get(
          `/api/products/${this.categoryId}/reviews`,
          { params: { page: this.page } },
        );

        this.reviews = this.reviews.concat(data.data);
        this.avgRating = data.meta?.avg_rating ?? 0;
        this.totalCount = data.meta?.reviews_total ?? 0;
        this.lastPage = data.meta?.last_page ?? 1;
      } catch {
        // Silently fail — reviews are non-critical
      } finally {
        this.loading = false;
      }
    },

    loadMore() {
      this.page += 1;
      this.fetchReviews();
    },
  },
};
</script>
